import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  LoadLocationsFlatAction, LoadLocationsFlatFailsAction, LoadLocationsFlatSuccessAction,
  LoadLocationsGroupedAction,
  LoadLocationsGroupedFailsAction,
  LoadLocationsGroupedSuccessAction,
  locationActionTypes as types, UpdateLocationAction, UpdateLocationFailsAction, UpdateLocationSuccessAction
} from './locations.actions';
import { LocationService } from '../shared/services/location.service';
import { TreeItem } from 'app/shared/components/dropdown-treeview';
import { PropertyComponentLocation } from '../../shared';

@Injectable()
export class LocationsEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private locationService: LocationService
  ) { }

  // All Locations Flat
  getLocationsFlat$ = createEffect(() => this.actions$.pipe(
    ofType(types.LOAD_LOCATIONS_FLAT),
    map(action => (action as LoadLocationsFlatAction).payload),
    mergeMap((payload) =>
      this.locationService
        .getAllLocationsFlat(payload)
        .pipe(
          map((response: PropertyComponentLocation[]) => new LoadLocationsFlatSuccessAction(response)),
          catchError((error) => of((new LoadLocationsFlatFailsAction(error))))
        )
    ))
  );

  // All Locations Grouped
  getLocationsGrouped$ = createEffect(() => this.actions$.pipe(
    ofType(types.LOAD_LOCATIONS_GROUPED),
    map(action => (action as LoadLocationsGroupedAction).payload),
    mergeMap((payload) =>
      this.locationService
        .getAllLocationsGrouped(payload)
        .pipe(
          map((response: TreeItem[]) => new LoadLocationsGroupedSuccessAction(response)),
          catchError((error) => of((new LoadLocationsGroupedFailsAction(error))))
        )
    )  )
  );

  // Update Location
  updateLocation$ = createEffect(() => this.actions$.pipe(
    ofType(types.UPDATE_LOCATION),
    map(action => (action as UpdateLocationAction).payload),
    mergeMap((payload) =>
      this.locationService
        .updateLocation(payload)
        .pipe(
          mergeMap((response: PropertyComponentLocation) => {
            return [
              new UpdateLocationSuccessAction(response),
              new LoadLocationsFlatAction(response.propertyId),
              new LoadLocationsGroupedAction(response.propertyId),
            ];
          }),
          catchError((error) => of((new UpdateLocationFailsAction(error))))
        )
    ))
  );
}
